import React from 'react';

const SuperToolLogo = ({ size = 64, animated = true }) => {
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={animated ? 'supertool-logo-animated' : ''}
      >
        {/* Outer rotating ring */}
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="url(#gradient1)"
          strokeWidth="2"
          fill="none"
          className="outer-ring"
        />
        
        {/* Middle rotating ring */}
        <circle
          cx="50"
          cy="50"
          r="35"
          stroke="url(#gradient2)"
          strokeWidth="1.5"
          fill="none"
          className="middle-ring"
          strokeDasharray="5 5"
        />
        
        {/* Inner core - hexagon tool shape */}
        <path
          d="M50 20 L70 35 L70 65 L50 80 L30 65 L30 35 Z"
          fill="url(#gradient3)"
          className="inner-core"
        />
        
        {/* Tool elements */}
        <g className="tool-elements">
          {/* Wrench */}
          <path
            d="M45 40 L48 37 L52 41 L49 44 Z"
            fill="white"
            opacity="0.9"
          />
          
          {/* Gear teeth */}
          <circle cx="50" cy="50" r="8" fill="white" opacity="0.9" />
          <circle cx="50" cy="50" r="5" fill="url(#gradient3)" />
          
          {/* Sparkles */}
          <circle cx="40" cy="35" r="1.5" fill="white" className="sparkle sparkle-1" />
          <circle cx="60" cy="35" r="1.5" fill="white" className="sparkle sparkle-2" />
          <circle cx="40" cy="65" r="1.5" fill="white" className="sparkle sparkle-3" />
          <circle cx="60" cy="65" r="1.5" fill="white" className="sparkle sparkle-4" />
        </g>
        
        {/* Pulse effect */}
        <circle
          cx="50"
          cy="50"
          r="48"
          stroke="url(#gradient1)"
          strokeWidth="0.5"
          fill="none"
          className="pulse-ring"
          opacity="0"
        />
        
        {/* Gradients */}
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="50%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#8b5cf6" />
          </linearGradient>
          
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
          
          <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="50%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>
      </svg>
      
      <style jsx>{`
        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes rotate-reverse {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }
        
        @keyframes pulse-ring {
          0% {
            r: 35;
            opacity: 0.6;
          }
          100% {
            r: 48;
            opacity: 0;
          }
        }
        
        @keyframes sparkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
        
        .supertool-logo-animated .outer-ring {
          animation: rotate 8s linear infinite;
          transform-origin: 50px 50px;
        }
        
        .supertool-logo-animated .middle-ring {
          animation: rotate-reverse 6s linear infinite;
          transform-origin: 50px 50px;
        }
        
        .supertool-logo-animated .inner-core {
          animation: pulse 2s ease-in-out infinite;
        }
        
        .supertool-logo-animated .pulse-ring {
          animation: pulse-ring 2s ease-out infinite;
        }
        
        .supertool-logo-animated .sparkle {
          animation: sparkle 1.5s ease-in-out infinite;
        }
        
        .supertool-logo-animated .sparkle-1 {
          animation-delay: 0s;
        }
        
        .supertool-logo-animated .sparkle-2 {
          animation-delay: 0.375s;
        }
        
        .supertool-logo-animated .sparkle-3 {
          animation-delay: 0.75s;
        }
        
        .supertool-logo-animated .sparkle-4 {
          animation-delay: 1.125s;
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
};

export default SuperToolLogo;
